import { styled, TextField, TextFieldProps } from "@mui/material";
import { ReactElement } from "react";

import { secondaryDropdownStyle } from "./SecondaryDropdown";

const StyledTextField = styled(TextField)(secondaryDropdownStyle);

export function SecondaryTextField(props: TextFieldProps): ReactElement {
  return <StyledTextField {...props} variant="standard" />;
}
